// The trip color-coding palette (design system). Named here (not in `core` or
// `ui-web`) because both need it: `core` validates a trip's optional `color` field
// against it, `ui-web` maps each name to a concrete swatch. A trip with no `color` set
// still gets a stable hue derived from its id (see `ui-web`'s `tripColorFor`) — this
// list is only the set of colors a user may explicitly choose in trip settings.
export const TRIP_COLORS = [
    "orange",
    "blue",
    "green",
    "purple",
    "pink",
    "teal",
    "indigo",
    "rose",
    "lime",
    "cyan",
];
//# sourceMappingURL=tripColors.js.map